import ShModel from './sh-model';
import { attr, belongsTo, hasMany } from '@ember-data/model';
import { isBlank } from 'sh-www/utils/misc';

class CompanyContact extends ShModel {
  @attr('string') firstName;
  @attr('string') lastName;
  @attr('string') email;

  //Relationships
  @belongsTo('company', { async: false, inverse: null }) company;

  @hasMany('costCode', { async: false, inverse: null }) costCodes;

  get fullName() {
    const firstName = this.firstName ?? '';
    const lastName = this.lastName ?? '';

    if (isBlank(firstName) && isBlank(lastName)) {
      return '';
    }

    return `${firstName} ${lastName}`.trim();
  }
}

export default CompanyContact;

